import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// Create axios instance for registration endpoints
const registrationApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to add auth token
registrationApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Registration API request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
registrationApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      console.error(`Registration API error: ${error.response.status} ${error.config?.method?.toUpperCase()} ${error.config?.url}`);
      console.error('Error response:', error.response.data);
      
      // Handle unauthorized errors (expired token, invalid token, etc.)
      if (error.response.status === 401) {
        console.log('Authentication error detected (401 Unauthorized) in registrationService, clearing storage and redirecting to login');
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login';
        return; // Don't continue processing this error
      }
      
      // Also handle 403 Forbidden as it might indicate token issues
      if (error.response.status === 403) {
        console.log('Access forbidden (403) in registrationService, checking if token is invalid');
        const errorMessage = error.response.data?.message?.toLowerCase() || '';
        if (errorMessage.includes('token') || errorMessage.includes('unauthorized') || errorMessage.includes('invalid')) {
          console.log('Token-related 403 error detected in registrationService, logging out user');
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/login';
          return;
        }
      }
    } else if (error.request) {
      console.error('Registration API: No response received:', error.request);
    } else {
      console.error('Registration API: Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);

// Registration service
export const registrationService = {
  // Register new user
  registerUser: (userData) => {
    console.log('🎯 [REGISTRATION] Registering new user:', userData);
    return registrationApi.post('/registration/register', userData);
  },

  // Update user profile
  updateProfile: (userId, profileData) => {
    console.log('🎯 [REGISTRATION] Updating profile for user:', userId, profileData);
    return registrationApi.put(`/registration/profile/${userId}`, profileData);
  },

  // Verify email
  verifyEmail: (email, token) => {
    console.log('🎯 [REGISTRATION] Verifying email:', email);
    return registrationApi.get(`/registration/verify/${email}/${token}`);
  },

  // Get registration statistics
  getStats: () => {
    console.log('🎯 [REGISTRATION] Getting registration statistics');
    return registrationApi.get('/registration/stats');
  },

  // Test registration endpoint
  testConnection: () => {
    console.log('🎯 [REGISTRATION] Testing connection to registration endpoint');
    return registrationApi.get('/registration/stats');
  }
};

export default registrationService; 